import { render, staticRenderFns } from "./RoomNumberRegistrationPopup.vue?vue&type=template&id=d3068b98&scoped=true&"
import script from "./RoomNumberRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./RoomNumberRegistrationPopup.vue?vue&type=script&lang=js&"
import style0 from "./RoomNumberRegistrationPopup.vue?vue&type=style&index=0&id=d3068b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3068b98",
  null
  
)

export default component.exports